import {AbstractEvent} from "@/modules/base/events";
import {DivisionPromotion, LeagueDivision, TableStatistics} from "@/modules/competitions/entity";
import {Team} from "@/modules/team/entity";

export class AfterLeaguePromotionEvent extends AbstractEvent {
  constructor(
    public team: Team,
    public from: LeagueDivision,
    public to: LeagueDivision,
    public promotion: DivisionPromotion,
    public stats: TableStatistics,
  ) {
    super();
  }
}